import { Typography } from '@mui/material';
import { useEffect } from 'react';

import { getInputDisplayStatus, logInputOverallStatus } from '@/models/input';

interface InputOverallStatusDisplayProps {
  overallStatus?: string | null;
  /** When true, badge/text use live preview player overlay styling. */
  overlay?: boolean;
}

const InputOverallStatusDisplay = ({ overallStatus, overlay = false }: InputOverallStatusDisplayProps) => {
  const displayStatus = getInputDisplayStatus(overallStatus);

  useEffect(() => {
    if (overallStatus != null) {
      logInputOverallStatus(overlay ? 'live preview display updated' : 'input list display updated', overallStatus);
    }
  }, [overallStatus, overlay]);

  if (displayStatus.showLiveBadge) {
    return (
      <div className={overlay ? 'live-badge player-live-overlay' : 'live-badge'}>
        <span className="live-dot" />
        {displayStatus.label}
      </div>
    );
  }

  if (!displayStatus.label) {
    return null;
  }

  if (overlay) {
    return (
      <Typography className="player-status-overlay" variant="body2">
        {displayStatus.label}
      </Typography>
    );
  }

  return displayStatus.label;
};

export default InputOverallStatusDisplay;
